import { service } from "@ember/service";
import DiscourseURL from "discourse/lib/url";
import Category from "discourse/models/category";
import DiscourseRoute from "discourse/routes/discourse";
import { i18n } from "discourse-i18n";

const WISH_MAPPING_KEY = "category.mod.wishes";

export default class CommunityWishesRoute extends DiscourseRoute {
  @service siteSettings;

  queryParams = {
    sort: { refreshModel: true },
    status: { refreshModel: true },
    game: { refreshModel: true },
    tag: { refreshModel: true },
    page: { refreshModel: true },
  };

  beforeModel() {
    if (
      this.siteSettings.community_navigation_enabled &&
      this.siteSettings.community_wishes_enabled
    ) {
      return;
    }

    const category = Category.findAll().find(
      (candidate) =>
        candidate.custom_fields?.community_navigation_key === WISH_MAPPING_KEY
    );
    if (category) {
      return DiscourseURL.routeTo(category.url);
    }

    return this.replaceWith("discovery.latest");
  }

  model({ sort = "latest", status = "all", game = "all", tag = "", page = 0 }) {
    return { sort, status, game, tag, page };
  }

  titleToken() {
    return i18n("community_feedback.wishes.title");
  }
}
